import theme from './theme';
import { LocalStorage } from 'utils';
import { ReactNode, useMemo } from 'react';
import { ThemeProvider as Provider, createTheme } from '@mui/material/styles';

type AppThemeProps = {
  children: ReactNode;
};

const ThemeProvider = ({ children }: AppThemeProps) => {
  const memoizedTheme = useMemo(() => createTheme(theme), []);

  const muiMode = LocalStorage.getItem('mui-mode');

  // for default setting to light especially in init
  if (muiMode === 'system') {
    LocalStorage.setItem('mui-mode', 'light');
  }

  return (
    <Provider theme={memoizedTheme} disableTransitionOnChange>
      {children}
    </Provider>
  );
};

export default ThemeProvider;
